import { message, Modal } from 'antd';
import { API } from 'data';
import { TbCreditCard } from 'react-icons/tb';
import { AppStorage, RestAPI, useAsyncClick } from 'scripts';
import { APPlicationStoreEnum, PaymentTypeEnum, PostType } from 'types';

export default function RenewPaymentComp(props: { onClose: () => void; post?: PostType<'detail'> }) {
    const __CalcPostPayment = () => {
        let locCof = 0;
        props.post?.locations?.map((l) => {
            locCof = locCof + (l.coefficient ?? 0);
        });
        return (props.post?.category.renewed_price ?? 0) * locCof;
    };

    const onClickPay = useAsyncClick(() => {
        return new Promise((resolve) => {
            if (AppStorage.applicationStore.get() === APPlicationStoreEnum.cafebazar) {
                RestAPI.post<{ payment_url: string }>(API.payment.bazarPay, {
                    type: PaymentTypeEnum.renew,
                    post: props.post?.id,
                })
                    .then((res) => (window.location.href = res.data.payment_url))
                    .catch(() => {
                        message.error('ورود به درگاه پرداخت با خطا مواجه شد. لطفا بعدا تلاش کنید');
                        resolve(false);
                    });
            } else {
                RestAPI.post<{ url: string }>(API.payment.pay, { type: PaymentTypeEnum.create, post: props.post?.id })
                    .then((res) => (window.location.href = res.data.url))
                    .catch(() => {
                        message.error('ورود به درگاه پرداخت با خطا مواجه شد. لطفا بعدا تلاش کنید');
                        resolve(false);
                    });
            }
        });
    });

    return (
        <Modal
            open={!!props.post}
            onCancel={props.onClose}
            onClose={props.onClose}
            onOk={onClickPay.onClick}
            okButtonProps={{ loading: onClickPay.loading, type: 'default' }}
            cancelButtonProps={{ type: 'primary' }}
            okText="ورود به صفحه پرداخت"
            title={
                <div className="align-items-center g-1">
                    <TbCreditCard className="t-l-black1 t-d-gray2" size={24} />
                    پرداخت امن هزینه نردبان آگهی
                </div>
            }
        >
            <p>
                هزینه نردبان آگهی شما توسط تیک سبز که بر اساس دسته‌بندی و موقعیت‌های مورد نظرتان محاسبه شده است برابر
                است با :
            </p>
            <h4 className="mt-2">{__CalcPostPayment()} ریال</h4>
        </Modal>
    );
}
